import _ from "lodash";
import { createSelector } from "reselect";

const usersKey = "PermitStepperText";

export const getAddPermitTextState = (state) => _.get(state, usersKey);
export const getAddpPermitwithSessionSelectorText = createSelector(
  getAddPermitTextState,
  (state) => _.get(state, "__htmlWithSession")
);
export const getAddpPermitWithoutSessionSelectorText = createSelector(
  getAddPermitTextState,
  (state) => _.get(state, "__htmlWithoutSession")
);

export const getAddPermitSelectDateSelector =createSelector(getAddPermitTextState,(state)=>_.get(state,'setpermitText'));
